




































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { GenericScrollView } from '@/shared/generic-scroll-view';
import ProductsFreetrialCard from './products-freetrial-card.vue';
import DefconProgress from '@/modules/msw-products/components/defcon-progress.vue';
import GetFriendlyName from './get-friendly-name.vue';
import { HostedEmailSecurityRoute } from '../msw-product-detail/todoComponents/hostedEmailSecurity';
import { envCongif } from '@/shared/env.config';

@Component({
  components:{
    ...UUIFComponent,
    GenericScrollView,
    ProductsFreetrialCard,
    DefconProgress,
    GetFriendlyName,
  },
})
export default  class MswFreeTrials extends SwExtendedVue{
  softwareTrialsWidgets = [];
  @Prop()
  defconValue:number;
  @Prop()
  shieldLevel:number;
  @Prop()
  productgroupId:any;
  @Watch('openGetFriendlyname')
  onOpenFriendlyName() {
    this.openGetFriendlyModalValues = {
      productID:this.productId,
      friendlyname:this.friendlyname,
      serviceId:this.serviceId,
      widgetTitle:this.widgetTitle,
      subDomain:this.subDomain,
      needcasbdc:this.needcasbdc,
      casbApps:this.casbApps,
      needCASBApp:this.needCASBApp,
      needCSE: this.needCSE,
      needCES: this.needCES,
      needTSE: this.needTSE,
      needTsemdr: this.needTsemdr,
      datacenters: this.datacenters,
    };
  }
  defconvalue:number = 0 ;
  shieldlevelvalue:number = 0;
  openGetFriendlyname:boolean = false;
  // invalidfriendlyName:boolean = false;
  productId:string = '';
  serviceId:string = '';
  widgetTitle:string = '';
  subDomain:string = '';
  tenantgroup:any;
  needcasbdc:boolean = false;
  needCSE: boolean = false;
  needCES: boolean = false;
  needTSE: boolean = false;
  needTsemdr: boolean = false;
  datacenters: any[] = [];
  openGetFriendlyModalValues:any;
  friendlyname:string = '';
  casbdcid:string = '';
  tenantgroupid:any;
  noCardsFound:boolean = false;
  needCASBApp:boolean = false;
  casbApps:any[] = [];
  casApplicationId:string = '';
  termsandConditionLink: string = '';
  cseAutoRedirect: string;

  created() {
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.cseAutoRedirect = result.content.cseAutoRedirect;
    });
  }
  mounted() {
    this.needCASBApp = false;
    this.tenantgroupid = this.productgroupId;
    this.defconvalue =  this.defconValue;
    this.shieldlevelvalue = this.shieldLevel;
    this.loadFreeTrials();
    this.termsandConditionLink = 'https://www.sonicwall.com/legal';
  }
  loadFreeTrials() {
    const request = {
      productGroupId : this.productgroupId,
    };
    this.$store.dispatch('MswProductsStoreModule/getSoftwareTrials', request)
      .then((res: any) => {
        if (res.operationStatus === 'OK' && res.msgCode ===  'MSWAPP:SUCCESS') {
          this.softwareTrialsWidgets = res.content.freeTrialWidgetsList;
          if (this.softwareTrialsWidgets.length === 0) {
            this.noCardsFound = true;
          }
        }
        this.$store.commit('stopLoading');
      });
  }

  closefreetrial() {
    this.$emit('closeFreeTrial');
  }
  onChangeShieldLevels(value:any) {
    if (value.mode === 'increment') {
      this.defconvalue += Number(value.defconValues);
      /*if (this.defconvalue > 5) {
        this.defconvalue = 5;
      }*/
      this.shieldlevelvalue += Number(value.shieldValues);
      /*if (this.shieldlevelvalue > 10) {
        this.shieldlevelvalue = 10;
      }*/
    } else {
      this.defconvalue -= Number(value.defconValues);
      if (this.defconvalue < 0) {
        this.defconvalue = 0;
      }
      this.shieldlevelvalue -= Number(value.shieldValues);
      if (this.shieldlevelvalue < 0) {
        this.shieldlevelvalue = 0;
      }
    }
  }
  onStartTrials(result:any) {
    this.casbdcid = '';
    this.casApplicationId = '';
    this.tryNow(result);
    // let bisfriendlyexpected:boolean = false;
  }
  tryNow(result:any) {
    // this.openGetFriendlyname = false;
    this.productId = result.productID;
    this.serviceId = result.serviceId;
    this.widgetTitle = result.widgetTitle;
    if (result.subDomain !== 'undefined' &&  result.subDomain !== '') {
      this.subDomain = result.subDomain;
    }
    this.openGetFriendlyname = true;
  }
  onCloseGetFriendlyname() {  // this close function execuits after getting datacenter values....
    this.needcasbdc = false; // added bug fix
    this.needCASBApp = false;
    this.friendlyname = '';  // added bug fix
    this.openGetFriendlyname = false;
    this.casbApps = [];
    this.needCSE = false;
    this.needCES = false;
    this.datacenters = [];
    this.subDomain = '';
  }

  ongotoFreeTrial(result:any) {
    this.openGetFriendlyname = false;
    if (result !== undefined) {
      if (result.success === true) {
        if (result.datacenter && result.datacenter.dataCenterId) {
          this.casbdcid = result.datacenter.dataCenterId;
        }
        if (this.casbdcid === '' && result.datacenter && result.datacenter.dataCenterName) {
          this.casbdcid = result.datacenter.dataCenterName;
        }
        if (this.casApplicationId === '' && result.casbapp) {
          this.casApplicationId = result.casbapp;
        }
        if (result.subDomain && (this.needCSE || this.needCES)) {
          this.subDomain = result.subDomain;
        }
        this.friendlyname = result.friendlyName;
        this.calltrynowApi();
      }
    }
  }
  calltrynowApi() {
    let data:any = {};
    if (this.productId === '298' || this.productId === '402' || this.serviceId === '6520' || this.serviceId === '6560' || this.productId === '401') {
             // tslint:disable-next-line:max-line-length
      data = { clientDistGroup: this.friendlyname , productId:this.productId , serviceId:this.serviceId, productGroupId:this.tenantgroupid, casbDataCenter:this.casbdcid, casApplicationId:this.casApplicationId };
    } else if (this.productId === '403') {
       // tslint:disable-next-line:max-line-length
      data = { clientDistGroup: this.friendlyname , productId:this.productId , serviceId:this.serviceId, productGroupId:this.tenantgroupid, casbDataCenter:this.casbdcid, casApplicationId:'' };
    } else if (this.needCSE || this.needCES) {
      data = {
        productId: this.productId,
        serviceId: this.serviceId,
        clientDistGroup: this.friendlyname,
        productGroupId: this.tenantgroupid,
        casbDataCenter: this.casbdcid,
        casApplicationId: this.casApplicationId,
        subDomain: this.subDomain,
      };
    } else if (this.productId === '412') {
      data = {
        clientDistGroup: this.friendlyname,
        productId:this.productId,
        serviceId:this.serviceId,
        productGroupId:this.tenantgroupid,
        casbDataCenter:this.casbdcid,
        casApplicationId:'',
      };
    } else if (this.productId === '410') {
      // tslint:disable-next-line:max-line-length
      data = { clientDistGroup: this.friendlyname , productId:this.productId , serviceId:this.serviceId, productGroupId:this.tenantgroupid, casbDataCenter:this.casbdcid };
    } else {
       // tslint:disable-next-line:max-line-length
      data = { productId:this.productId , serviceId:this.serviceId, clientDistGroup: this.friendlyname, productGroupId:this.tenantgroupid };
    }
    this.$store
      .dispatch('MswProductsStoreModule/tryNowApi', data)
      .then((resp:any) => {
        if (resp.operationStatus === 'OK') {
          this.$store.commit('stopLoading');
          if (resp.msgCode === 'MSWAPP:NEEDCASBDATACENTER') {
            this.needcasbdc = true;
            // this.onCloseGetFriendlyname();
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
            // return;
          } else if (resp.msgCode === 'MSWAPP:NEEDCASAPP') {
            this.casbApps =  resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('casbAppList') ?
            resp.content.casbAppList : [] : [];
            this.needcasbdc = false;
            this.needCASBApp = true;
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
          } else if (resp.msgCode === 'MSWAPP:NEEDSASEDATACENTER') {
            if (resp.datacenters.length === 1 && this.productId === '403') {
              this.casbdcid = resp.datacenters[0].dataCenterId;
              this.calltrynowApi();
            } else {
              this.needcasbdc = true;
              const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
              this.tryNow(req);
            }
          } else if (resp.msgCode === 'MSWAPP:NEEDTSEDATACENTER') {
            this.needTSE = true;
            this.datacenters = resp.datacenters;
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
          } else if (resp.msgCode === 'MSWAPP:NEEDCESDATACENTER') {
            this.needCES = true;
            this.datacenters = resp.datacenters;
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
          } else if (resp.msgCode === 'MSWAPP:NEEDTSEMDRDATACENTER') {
            this.needTsemdr = true;
            this.datacenters = resp.datacenters;
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
          } else if (resp.msgCode === 'MSWAPP:NEEDCSEDATACENTER') {
            this.needCSE = true;
            this.datacenters = resp.datacenters;
            const req = { productID:this.productId, serviceId:this.serviceId, subDomain:this.subDomain };
            this.tryNow(req);
          } else {
            if (this.cseAutoRedirect === 'YES' && this.productId === '409') {
              const request = {
                tenant: this.tenantgroupid,
                tileName: 'ISMSWSAFEENABLED',
              };
              this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
              .then((resp: any) => {
                if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                  const cscAccessCode = resp?.content?.accessCode;
                  window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.tenantgroupid}`, '_blank');
                }
              })
              .catch((err: any) => {
                this.$store.commit('stopLoading');
                console.error(err);
              })
              .finally(() => {
                this.$store.commit('stopLoading');
              });
            }
            this.friendlyname = ''; // added bug fix
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            setTimeout(() => { this.callSuccess(resp); }, 500);
          }
        } else {
          this.$store.commit('stopLoading');
          this.needcasbdc = false;  // added bug fix
          this.friendlyname = '';
          this.casbdcid = '';
          this.needCASBApp = false;
          this.casbApps = [];
          this.needCSE = false;
          this.needCES = false;
          this.needTsemdr = false;
          this.datacenters = [];
          this.subDomain = '';
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      })
      .catch((error) => {
        this.$store.commit('stopLoading');
        this.needcasbdc = false;  // added bug fix
        this.friendlyname = '';
        this.casbdcid = '';
        this.needCASBApp = false;
        this.casbApps = [];
        this.needCSE = false;
        this.needCES = false;
        this.needTsemdr = false;
        this.datacenters = [];
        this.subDomain = '';
        console.error(error);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('common.errorOccured').toString() });
      });
  }
  callSuccess(resp:any) {
    this.needcasbdc = false;
    this.needCASBApp = false;
    this.needTsemdr = false;
    this.friendlyname = '';
    this.casbdcid = '';
    this.casbApps = [];
    // added bug fix
    if (this.productId === '300') {
      this.$router.push({ path: HostedEmailSecurityRoute.path, query: { SN : resp.serialNumber } });
    } else {
      if (this.productId === '402') {
        this.onCloseGetFriendlyname();
        this.closefreetrial();
        if (this.$store.getters.isLargeCustomer) {
          this.loadRegisterProductData(resp);
        }
        this.$emit('loadProductList');
        this.$emit('navigateToProductDetails', resp.serialNumber);
      } else {
        this.onCloseGetFriendlyname();
        this.closefreetrial();
        if (this.$store.getters.isLargeCustomer) {
          this.loadRegisterProductData(resp);
        }
        this.$emit('loadProductList');
        this.$emit('navigateToProductDetails', resp.serialNumber);
      }
    }
  }
  loadRegisterProductData(resp : any) {
    const d = new Date();
    const req = {
      associationType: '',
      casNodeCount: '0',
      ccNodeCount: '0',
      cloudBackupTab: false,
      dtExpired: '',
      dtExpiring: '',
      dtRegistrationDate: `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`,
      dtSupportExpiry: '',
      firmWareTab: false,
      firmwareStatus: '',
      firmwareVersion: '',
      friendlyName: '',
      gmsNodeCount: '0',
      hesNodeCount: '0',
      id: '',
      isDeleteAllowed: 'YES',
      isDownloadAvailable: false,
      isLicenseExpired: false,
      isLicenseExpiring: false,
      isRenameAllowed: 'YES ',
      isSharedProduct: 'NO',
      isTransferAllowed: 'YES',
      isZTEnable: false,
      pID: '',
      pTab: true,
      productDesc: '',
      productGroup: '',
      productName: '',
      productType: '',
      registrationDate: this.getTodayDate(),
      releaseStatus: '',
      saseNodeCount: '0',
      serNo: resp.serialNumber,
      sharedGroupHoverText: '',
      status: 'ENABLED',
      supportExpiry: '',
      userGroups: '',
    };
    const registeredDataCopy = localStorage.getItem('registeredData');
    if (registeredDataCopy !== undefined && registeredDataCopy !== null) {
      const reqArr = JSON.parse(registeredDataCopy);
      reqArr.push(req);
      localStorage.setItem('registeredData', JSON.stringify(reqArr));
    } else {
      const reqArr = [];
      reqArr.push(req);
      localStorage.setItem('registeredData', JSON.stringify(reqArr));
    }
  }
  getTodayDate() {
    const d = new Date();
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthArr[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`;
  }
}
